import React from 'react';
import { render } from 'react-dom';

import { RelationshipDisplayGroups } from 'features/productRelationships/components';
import { getFormattedGroupLabel } from 'features/productRelationships/utility';

let videoPlayButtonHidden = false;

function getHeroImageElement () {

	return document.querySelector('.pdImgWrap.active .pdProdImg') || document.querySelector('.pdImgWrap .pdProdImg');

}

document.addEventListener('productRelationships:RelationshipItemDetail:imageMouseOver', (e) => {

	const { heroImageUrl, productName } = e.detail;

	const activeHeroElement = getHeroImageElement();
	const videoSpanElement = document.querySelector('#pdImgContainer .playButton');
	const newUrl = heroImageUrl;

	if (activeHeroElement && newUrl) {

		if (videoSpanElement) {

			videoSpanElement.classList.add('hidden');
			videoPlayButtonHidden = true;

		}

		// store original src for hero image before mouse leave
		activeHeroElement.setAttribute('data-original-src', activeHeroElement.src);
		activeHeroElement.src = newUrl;
		activeHeroElement.alt = productName || '';

	}

});

document.addEventListener('productRelationships:RelationshipItemDetail:imageMouseLeave', () => {

	const activeHeroElement = getHeroImageElement();

	if (activeHeroElement) {

		const { originalSrc } = activeHeroElement.dataset;
		// set hero image to original source when mouse leaves
		if (originalSrc) {

			activeHeroElement.src = originalSrc;

		}

		if (videoPlayButtonHidden) {

			document.querySelector('#pdImgContainer .playButton').classList.remove('hidden');
			videoPlayButtonHidden = false;

		}

	}

});

function initProductRelationships (interfaceType, relationshipGroupData) {

	const rdsContainer = document.getElementById(`rds-${interfaceType}`);

	if (!rdsContainer || !Array.isArray(relationshipGroupData) || relationshipGroupData.length === 0) {

		return;

	}

	const groups = relationshipGroupData.map((group) => ({
		...group,
		label: getFormattedGroupLabel(group.label)
	}));

	render(
		<RelationshipDisplayGroups groups={groups} interfaceType={interfaceType} activeShortSku={window.shortSku} />,
		rdsContainer
	);

}

export default initProductRelationships;
